import { AbstractControl, FormArray } from '@angular/forms';
import { deepEqual, replaceNullsWithEmptyStrings } from './assert';
/**
 * This function checks duplicate input values between form array.
 * If there is duplicate, set new error with error code 'duplication' with true.
 *
 * @param control
 * @param formArray
 */
export function checkDuplicateBetweenFields(control: AbstractControl, formArray: FormArray): void {
  const controlValue = control.value;
  if (!controlValue || !formArray) {
    return;
  }

  const isDuplicated = formArray.getRawValue().filter(value => value === controlValue).length > 1;

  if (isDuplicated) {
    control.setErrors({ duplication: true });
  } else if (control.errors && control.hasError('duplication')) {
    delete control.errors['duplication'];
    // Should set explicitly null, if control has no more errors
    if (!Object.keys(control.errors).length) {
      control.setErrors(null);
    }
  }
}

export const NO_VALUE_OPTION = 'NONE';
export const ALL_OPTION = 'ALL-OPTION-VALUE';

export function setEmptyStringPropertiesToNull(obj: any): void {
  for (const prop in obj) {
    if (
      typeof obj[prop] === 'string' &&
      ((obj[prop] as string).trim() === '' || (obj[prop] as string) === NO_VALUE_OPTION)
    ) {
      obj[prop] = null;
    } else if (typeof obj[prop] === 'object' && obj[prop] !== null) {
      setEmptyStringPropertiesToNull(obj[prop]);
    }
  }
}

export function isFormUnChanged(currentValue: any, initialValue: any): boolean {
  const currentForm = replaceNullsWithEmptyStrings(currentValue);
  const initialForm = replaceNullsWithEmptyStrings(initialValue);

  return deepEqual(currentForm, initialForm);
}
